import { useState } from 'react';
import { FaCheckCircle, FaSpinner } from 'react-icons/fa';
import { SITE_DOMAIN } from '../constants/site';
import { WEB3FORMS_ACCESS_KEY, WEB3FORMS_ENDPOINT } from '../constants/web3forms';
import './LeadForm.css';

const initialForm = {
  name: '',
  email: '',
  phone: '',
  model: '',
};

export default function LeadForm({
  id = 'quote',
  title = 'Request a Map Update',
  compact = false,
  popup = false,
  onSuccess,
}) {
  const [form, setForm] = useState(initialForm);
  const [status, setStatus] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus('');

    const payload = new FormData();
    payload.append('access_key', WEB3FORMS_ACCESS_KEY);
    payload.append('name', form.name);
    payload.append('email', form.email);
    payload.append('phone', form.phone);
    payload.append('gps_model', form.model);
    payload.append('subject', `GPS Map Update Request - ${form.model}`);
    payload.append('from_name', 'GPS Map Updates');
    payload.append(
      'message',
      `New map update request from ${SITE_DOMAIN}\n\nName: ${form.name}\nEmail: ${form.email}\nPhone: ${form.phone}\nGPS Model: ${form.model}`,
    );

    try {
      const response = await fetch(WEB3FORMS_ENDPOINT, {
        method: 'POST',
        body: payload,
      });
      const data = await response.json();

      if (data.success) {
        setStatus('success');
        setForm(initialForm);
        onSuccess?.();
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form
      id={popup ? undefined : id}
      className={`lead-form ${compact ? 'lead-form--compact' : ''} ${popup ? 'lead-form--popup' : ''}`}
      onSubmit={handleSubmit}
    >
      {!compact && (
        <div className="lead-form-header">
          <h3 id={popup ? 'lead-form-popup-title' : undefined}>{title}</h3>
          <p>Tell us about your device — we&apos;ll guide you through the right map update at {SITE_DOMAIN}.</p>
        </div>
      )}

      <div className="lead-form-grid">
        <label>
          <span>Name</span>
          <input
            name="name"
            value={form.name}
            onChange={handleChange}
            required
            placeholder="Your name"
            disabled={isSubmitting}
          />
        </label>
        <label>
          <span>Email</span>
          <input
            name="email"
            type="email"
            value={form.email}
            onChange={handleChange}
            required
            placeholder="you@email.com"
            disabled={isSubmitting}
          />
        </label>
        <label>
          <span>Phone No</span>
          <input
            name="phone"
            type="tel"
            value={form.phone}
            onChange={handleChange}
            required
            placeholder="Phone number"
            disabled={isSubmitting}
          />
        </label>
        <label>
          <span>GPS Model Name</span>
          <input
            name="model"
            value={form.model}
            onChange={handleChange}
            required
            placeholder="e.g. Garmin Drive 52"
            disabled={isSubmitting}
          />
        </label>
      </div>

      <button type="submit" className="btn btn-primary lead-form-submit" disabled={isSubmitting}>
        {isSubmitting ? (
          <>
            <FaSpinner className="lead-form-spinner" aria-hidden="true" />
            Submitting...
          </>
        ) : (
          'Submit'
        )}
      </button>

      {status === 'success' && (
        <p className="lead-form-success" role="status">
          <FaCheckCircle aria-hidden="true" />
          Thanks! Our map update team will reach out shortly.
        </p>
      )}

      {status === 'error' && (
        <p className="lead-form-error" role="alert">
          Something went wrong. Please try again or email us directly.
        </p>
      )}
    </form>
  );
}
